import OwlCarousel from 'react-owl-carousel3';
import { Link } from "react-router-dom";
import React, { useState } from 'react';
import ImgmFavorite from '../../assets/img/favorite.png';

import 'react-loading-skeleton/dist/skeleton.css'
import Currency from './Currency';
import LocalizedStrings from 'react-localization';
import localizations from "../../localization";
let strings = new LocalizedStrings(localizations);

const ProductSearch = (Props) => {

  const [comman, setComman] = useState({
    setfavorite: ImgmFavorite,
    type: 'add'
  });

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("current_lang")
      ? localStorage.getItem("current_lang")
      : "en"
  );
  strings.setLanguage(currentLang);

  return (
    <>
      <OwlCarousel className="search-product-carousel owl-carousel owl-theme" {...Props.options} >
        {Props.data.map((item, index) =>
          item.banner_type == 'video' ?
            <video width="100%" height={487} controls>
              <source src={item.file} type="video/mp4" />
              <source src={item.file} type="video/ogg" />
              <source src={item.file} type="video/webm" />
            </video> : <div className="item" key={index}>
              <div className="arrival-prd">
                <div className="badge-stack">
                  {item.is_new == 1 && (
                    <span className="badge badge-new">
                      + {strings.new || 'NEW'}
                    </span>
                  )}

                  {item.is_sale == 1 && (
                    <span className="badge badge-sale">
                      {(Math.round(((item.original_price - item.discount_price) * 100) / item.original_price).toFixed(0))}% {strings.sale || 'SALE'}
                    </span>
                  )}
                </div>
                <div className="arrival-prd-img">
                  <Link to={'/product-detail/' + item.slug} target="_blank">
                    <div className="img-container">
                      <img src={item.image} alt={item.name} />
                    </div>
                  </Link>
                </div>
                <div className="arrival-cont arrival-search-cont">
                  <div className="arrival-title">
                    <h3>
                      <Link to={`/product-detail/${item.slug}`} style={{textDecoration: 'none'}} target="_blank">{item.name}</Link>
                    </h3>
                    {item.brands?.name && (
                      <Link to={`/brand/${item.brands.slug}`} style={{ textDecoration: 'none' }}>
                        <p className="prd-brand-name">{item.brands.name}</p>
                      </Link>
                    )}
                  </div>

                  {/* Price + cart/notify icon — 2 columns */}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px', minHeight: '50px' }}>

                    {/* Left: prices */}
                    <div className="arrival-price" style={{ margin: 0 }}>
                      <p>
                        <Currency data={item.discount_price != 0 ? item.discount_price : item.original_price} />
                      </p>
                      {parseInt(item.discount_price) != 0 &&
                        <p className="discount-price"><span><Currency data={item.original_price} /></span></p>
                      }
                    </div>

                    {/* Right: add-to-cart (in stock) or notify-me (out of stock) */}
                    {Props.showAddtoCart && item.out_of_stock != 1 && item.left !== 0 ? (
                      <button
                        onClick={(e) => Props.showAddtoCart(e, item)}
                        title="Add to cart"
                        style={{
                          flexShrink: 0,
                          background: 'none',
                          border: '1px solid #f6157b',
                          borderRadius: '6px',
                          padding: '4px 6px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#f6157b',
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                        </svg>
                      </button>
                    ) : (item.out_of_stock == 1 || item.left === 0) && (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (Props.showNotifyMe) Props.showNotifyMe(e, item);
                          else window.open('/product-detail/' + item.slug, '_blank');
                        }}
                        title="Notify me"
                        style={{
                          flexShrink: 0,
                          background: 'none',
                          border: '1px solid #ccc',
                          borderRadius: '6px',
                          padding: '4px 6px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#888',
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                        </svg>
                      </button>
                    )}
                  </div>

                </div>
              </div>
            </div>
        )}
      </OwlCarousel>
    </>
  )
}
export default ProductSearch;
